import React, { useEffect } from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";
import ReactGA from "react-ga4";

import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import { Paper, Typography, Input } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";

import history from "../../history";

import Slide from "@material-ui/core/Slide";
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { useDispatch, useSelector } from "react-redux";

import withTimer from "components/Timer/withTimer";
import { filterCaseInsensitive } from "scripts/util";
import { reactTableHelper } from "scripts/util";
import { Button, Link } from "@mui/material";
import { EMPLOYEE_RANKING_REQUESTED } from "redux/actions";
import MonthYearSelector from "components/MonthYearSelector/MonthYearSelector";
import { useMediaQuery } from "react-responsive";

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const SelectTable = ReactTable;

const RankingTable = () => {
  const [data, setData] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [selection, setSelection] = React.useState([]);
  const [filterData, setFilterData] = React.useState([]);
  const [selectedMonth, setSelectedMonth] = React.useState("");
  const [selectedYear, setSelectedYear] = React.useState("");

  const employeeRanking = useSelector((state) => state.user.employeeRanking);

  function isSelected(key) {
    return selection.includes(`select-${key}`);
  }
  React.useEffect(() => {
    setData(employeeRanking || []);
  }, [employeeRanking]);
  React.useEffect(() => {
    setFilterData(data || []);
  }, [data]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: EMPLOYEE_RANKING_REQUESTED,
    });
  }, []);

  function getBGColor(row) {
    if (row.followUpDate) {
      return "#fada5e";
    }
    return undefined;
  }
  function getTrProps(state, rowInfo) {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e) => {
          e.preventDefault();
          history.push(`/admin/user-dashboard/${rowInfo.row._original.id}`);
          ReactGA.event({
            category: "Lead",
            action: "View Lead Profile",
          });
        },
        // style: {
        //   background: getBGColor(rowInfo.row._original),
        // },
      };
    } else {
      return {};
    }
  }
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      width: 50,
      height: 10,
    },
    {
      sortable: false,
      Header: <b>Name-Mail</b>,
      accessor: (row) => ({
        firstName: row?.firstName,
        middleName: row?.middleName,
        lastName: row?.lastName,
        email: row?.email,
      }),
      id: "nameAndEmail",
      Cell: ({ value }) => (
        <>
          <h6>
            {value?.firstName} {value?.middleName} {value?.lastName}
          </h6>{" "}
          ({value?.email})
        </>
      ),
      width: 100,
    },
    {
      sortable: false,

      Header: () => (
        <>
          <b>C. Rate</b>
        </>
      ),
      accessor: (row) => ({
        totalClient: row?.clientCount,
        convertedClient: row?.convertedCount,
      }),
      Cell: ({ value }) => (
        <>{((value?.convertedClient / value?.totalClient) * 100).toFixed(2)}</>
      ),
      id: "crate",
      width: 100,
    },
    {
      sortable: true,

      Header: () => (
        <>
          <b>T. Clients</b>
        </>
      ),
      accessor: "clientCount",
      width: 100,
    },
    {
      sortable: false,

      Header: () => (
        <>
          <b>Converted</b>
        </>
      ),
      accessor: "convertedCount",
      width: 100,
    },
    {
      sortable: false,

      Header: () => (
        <>
          <b>lost</b>
        </>
      ),
      accessor: (row) => ({
        totalClient: row?.clientCount,
        convertedClient: row?.convertedCount,
      }),
      Cell: ({ value }) => <>{value?.totalClient - value?.convertedClient}</>,
      id: "lost",
      width: 60,
    },
  ];
  function handleFilter() {
    if (selectedMonth && selectedYear) {
      const now = new Date();
      const date = new Date(`${selectedYear}-${selectedMonth}-01`);
      dispatch({
        type: EMPLOYEE_RANKING_REQUESTED,
        payload: {
          from: date,
          to: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        },
      });
    }
  }
  function toggleAll() {
    const keyField = "id";
    const newSelectAll = !selectAll;
    const newSelection = [];

    if (newSelectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = reactTableRef.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach((item) => {
        newSelection.push(`select-${item._original[keyField]}`);
      });
    }
    setSelection(newSelection);
    setSelectAll(newSelectAll);
  }
  function toggleSelection(key, shift, row) {
    // start off with the existing state
    let newSelection = [...selection];
    const keyIndex = newSelection.indexOf(key);

    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      newSelection = [
        ...newSelection.slice(0, keyIndex),
        ...newSelection.slice(keyIndex + 1),
      ];
    } else {
      // it does not exist so add it
      newSelection.push(key);
    }
    // update the state
    setSelection(newSelection);
  }
  const defaultSorted = [
    {
      id: "crate",
      desc: true, // false for ascending, true for descending
    },
  ];

  let reactTableRef = null;

  return (
    <Paper elevation={3} sx={{ borderRadius: 8, overflow: "hidden" }}>
      <GridContainer>
        <GridItem xs={12}>
          <CardBody>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <div>
                <Typography variant="h5" style={{ marginBottom: "30px" }}>
                  Employee Ranking
                </Typography>
              </div>
              <div>
                <MonthYearSelector
                  selectedMonth={selectedMonth}
                  selectedYear={selectedYear}
                  onMonthChange={setSelectedMonth}
                  onYearChange={setSelectedYear}
                />
              </div>
            </div>
            <div
            style={{
              maxHeight: "350px",
              overflowY: "scroll", // Enable vertical scroll
            }}
          >

            <SelectTable
              keyField="id"
              toggleSelection={toggleSelection}
              selectAll={selectAll}
              selectType="checkbox"
              toggleAll={toggleAll}
              isSelected={isSelected}
              ref={(r) => (reactTableRef = r)}
              // pageSizeOptions={[25, 50, 100]}
              data={filterData}
              // filterable
              resizable={true}
              getTrProps={getTrProps}
              columns={columns}
              // loading={}
              // defaultPageSize={5}
              showPagination={false}
              defaultFilterMethod={filterCaseInsensitive}
              defaultSorted={defaultSorted}
              className="-striped -highlight"
              getTableProps={ (state, rowInfo, column, rtInstance) => { return { style: { overflow: "unset"} } } }
            >
              {(state, makeTable, instance) => {
                return reactTableHelper(state, makeTable, false);
              }}
            </SelectTable>
            </div>
            <Link
              sx={{
                cursor: "pointer",
              }}
              onClick={() => handleFilter()}
            >
              > View Complete Report
            </Link>
          </CardBody>
          {/* </Card> */}
        </GridItem>
      </GridContainer>
    </Paper>
  );
};

export default withTimer(RankingTable);
